const SplitCashBankBar = ({
  bank = 0,
  cash = 0,
  currency = "UGX",
  compact = false,
}) => {
  const b = Math.max(0, Number(bank) || 0);
  const c = Math.max(0, Number(cash) || 0);
  const total = b + c;

  const bankPct = total > 0 ? (b / total) * 100 : 50;
  const cashPct = total > 0 ? (c / total) * 100 : 50;

  return (
    <div className={`yx-splitbar ${compact ? "yx-splitbar--compact" : ""}`}>
      <div className="d-flex align-items-end justify-content-between mb-2">
        <div className="yx-splitbar-legend">
          <span className="yx-splitbar-key">
            <span className="yx-splitbar-dot yx-splitbar-dot--bank" />
            Bank
            <span className="yx-splitbar-sub">
              {currency} {Number(b).toLocaleString()}
            </span>
          </span>

          <span className="yx-splitbar-key">
            <span className="yx-splitbar-dot yx-splitbar-dot--cash" />
            Cash
            <span className="yx-splitbar-sub">
              {currency} {Number(c).toLocaleString()}
            </span>
          </span>
        </div>

        <div className="yx-splitbar-total">
          <div className="yx-muted" style={{ fontSize: 12, fontWeight: 900 }}>
            Total
          </div>
          <div className="yx-row" style={{ fontSize: 14, fontWeight: 950 }}>
            {currency} {Number(total).toLocaleString()}
          </div>
        </div>
      </div>

      <div className="yx-splitbar-track" role="progressbar" aria-valuemin={0} aria-valuemax={100}>
        <div className="yx-splitbar-seg yx-splitbar-seg--bank" style={{ width: `${bankPct}%` }} />
        <div className="yx-splitbar-seg yx-splitbar-seg--cash" style={{ width: `${cashPct}%` }} />
      </div>

      <div className="d-flex justify-content-between mt-2">
        <span className="yx-splitbar-pct">
          Bank {total > 0 ? bankPct.toFixed(1) : "50.0"}%
        </span>
        <span className="yx-splitbar-pct">
          Cash {total > 0 ? cashPct.toFixed(1) : "50.0"}%
        </span>
      </div>
    </div>
  );
};
export default SplitCashBankBar;